import React, { useState } from "react";
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  Chip,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { AddCircleOutline, Cancel } from "@mui/icons-material";
import ContentBlocksListHome from "./ContentBlockListHome";
import { MuiLoadingButton } from "../../components";




// (Opcional) TemplateGeneratorButton si quieres generar Banners por defecto
// import TemplateGeneratorButton from "./TemplateGeneratorButton";



interface HomePageData {
  id?: string;

  // Aquí va lo que guardas finalmente en la base de datos

  jsonContent?: string;  // o banners: Banner[] directamente, depende de tu backend
}

interface HomePageFormProps {
  // Propiedades que necesites (por ejemplo, si es edición, etc.)
  initialData?: HomePageData;
  loading?: boolean;
  onSubmit: (data: HomePageData) => void;
  checkSlug?: (slug: string) => Promise<boolean>;
}

const HomePageForm: React.FC<HomePageFormProps> = ({
  initialData,
  loading,
  onSubmit,
  checkSlug,
}) => {
  const [isEditing, setIsEditing] = useState(!initialData?.id);

  const [banners, setBanners] = useState<any[]>(() => {
    // Si viene algo en initialData.jsonContent, parsearlo
    if (initialData?.jsonContent) {
      try {
        const parsed = JSON.parse(initialData.jsonContent);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    }
    return [];
  });

  // Manejo de keywords como chips
  // const initialKeywords = initialData?.seo?.keywords
  //   ? initialData.seo.keywords.split(",").map((k) => k.trim()).filter(Boolean)
  //   : [];
  // const [keywordChips, setKeywordChips] = useState<string[]>(initialKeywords);
  // const [newKeyword, setNewKeyword] = useState("");

  // Ejemplo de validación con Yup
  const validationSchema = Yup.object().shape({
    seo: Yup.object().shape({
      slug: Yup.string().required("Slug requerido"),
      title: Yup.string().required("Título SEO requerido"),
      description: Yup.string().max(300, "Máximo 300 caracteres."),
    }),
    // Si tuvieras otros campos de la Home aparte de SEO, agrégalos acá
  });

  const formik = useFormik({
    initialValues: {
      id: initialData?.id || "",
      // seo: {
      //   slug: initialData?.seo?.slug || "",
      //   title: initialData?.seo?.title || "",
      //   description: initialData?.seo?.description || "",
      //   keywords: initialData?.seo?.keywords || "",
      // },
      jsonContent: initialData?.jsonContent || "",
    },
    // validationSchema,
    onSubmit: async (values) => {
      console.log("Form values", values);
      // Convertimos banners a JSON
      const finalJson = JSON.stringify(banners);

      // Preparamos las keywords
      // const finalKeywords = keywordChips.join(",");

      const dataToSave: HomePageData = {
        ...values,
        // seo: {
        //   ...values.seo,
        //   keywords: finalKeywords,
        // },
        jsonContent: finalJson,
      };

      // (Opcional) Comprobación del slug en backend
      // if (checkSlug) {
      //   const isUsed = await checkSlug(values.seo.slug);
      //   if (isUsed) {
      //     // Manejo de error, etc.
      //     return;
      //   }
      // }

      onSubmit(dataToSave);
    },
  });

  // Manejo de keywords (chips)
  // const handleAddKeyword = () => {
  //   const kw = newKeyword.trim();
  //   if (!kw) return;
  //   if (!keywordChips.includes(kw)) {
  //     setKeywordChips((prev) => [...prev, kw]);
  //   }
  //   setNewKeyword("");
  // };

  // const handleRemoveKeyword = (kw: string) => {
  //   setKeywordChips((prev) => prev.filter((k) => k !== kw));
  // };




  const handleCancelClick = () => {
    formik.resetForm();
    setIsEditing(false);
  };

  return (
    <form onSubmit={formik.handleSubmit} >
      {/* <Box sx={{ mb: 4 }} >
        <Typography variant="h5" gutterBottom>
          Configuración de la Home
        </Typography>
      </Box> */}

     


      {/* SECCIÓN DE MÓDULOS (BANNERS) */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          Módulos de la Home
        </Typography>
        {/* <pre>{JSON.stringify(initialData, null, 2)}</pre> */}

        {/* Aquí podrías usar un botón "Generar Plantilla" si quieres */}
        {/* <Box mb={2}>
          <TemplateGeneratorButton
            disabled={false}
            onGenerateTemplate={setBanners}
          />
        </Box> */}

        <ContentBlocksListHome
          blocks={banners}
          setBlocks={setBanners}
          disabled={!isEditing}
        />
      </Box>

      {/* BOTÓN GUARDAR */}
      {/* <Box mt={4} display="flex" justifyContent="flex-end" >
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={!formik.isValid}
        >
          Guardar cambios
        </Button>
      </Box> */}

      <Box display="flex" justifyContent="flex-end" gap={2} mt={5}>
        {!initialData?.id && (
          <Box>
            <MuiLoadingButton
              title="Crear"
              variant="contained"
              color="primary"
              type="submit"
              disabled={loading}
              isLoading={loading}
            />
          </Box>
        )}
        {initialData?.id && !isEditing && (
          <Button
            variant="contained"
            color="primary"
            onClick={() => setIsEditing(true)}
            disabled={loading}
          >
            Editar
          </Button>
        )}
        {initialData?.id && isEditing && (
          <Box display="flex" gap={2}>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleCancelClick}
              disabled={loading}
            >
              Cancelar
            </Button>
            <Box>
              <MuiLoadingButton
                title="Guardar"
                variant="contained"
                color="primary"
                type="submit"
                disabled={loading}
                isLoading={loading}
              />
            </Box>
          </Box>
        )}
      </Box>

    </form>
  );
};

export default HomePageForm;
